





































































































import * as GoodsBlocks from './blocks'
import {
  computed,
  onActivated,
  onBeforeMount,
  onBeforeUnmount,
  ref,
} from '@vue/composition-api'
import { defineClassComponent, useQuery } from '@/hooks'
import { getGoodsData, GoodsData } from './utils'
import { goodsModel } from './store'
import { goodsProvider } from './provider'
import { pageBridge } from '@/components'
import { router } from '@/router'
import { Track } from '@/utils'

export default defineClassComponent(
  {
    components: {
      ...GoodsBlocks,
    },
  },
  () =>
    class {
      constructor() {
        Track.useMark(
          () => ({
            page: '商品详情页',
            id: this.goodsData.value.commodityId,
            name: this.goodsData.value.commodityTitle,
          }),
          () => !!this.goodsData.value.commodityId,
        )

        // 提供商品数据
        goodsProvider.provide(this.goodsData)

        onActivated(async () => {
          if (this.goodsData.value.noRefresh) {
            this.goodsData.value.noRefresh = false
            return
          }

          // 释放商品数据
          this.goodsData.value.$destroy?.()

          // 获取商品数据
          const previewStatus = router.currentRoute.query.previewStatus
          const parsedPreviewStatus = previewStatus
            ? parseInt(previewStatus as string, 10)
            : undefined
          this.goodsData.value = (await getGoodsData({
            goodsId: router.currentRoute.query.id as any,
            parentCommodityId: router.currentRoute.query
              .parentCommodityId as string,
            skuId: router.currentRoute.query.skuId as string,
            isExchange: router.currentRoute.query.type === 'exchange',
            previewStatus: parsedPreviewStatus,
          }))!
          goodsModel.update({
            销售渠道ID: (router.currentRoute.query.sellChannelId ||
              '') as any,
          })
          this.loading.value = false
          Track.pushEvent({
            type: 'load',
            name: '浏览商品详情页',
            id: 'LiuLanShangPinXiangQing',
            extra: {
              commodity_source: Track.getFrom(),
              commodity_id: this.goodsData.value.commodityId,
              commodity_name: this.goodsData.value.commodityTitle,
              commodity_tag:
                this.goodsData.value.commodityLabel?.join(',') || '',
              original_price: this.goodsData.value.dashPrice,
              present_price: this.goodsData.value.lowestPrice,
              discount_price:
                this.goodsData.value.dashPrice -
                this.goodsData.value.lowestPrice,
              store_id: this.goodsData.value.merchantId,
              store_name: this.goodsData.value.merchantName,
            },
          })
        })

        onBeforeMount(() => {
          // 获取头部下拉进度
          const offScroll = pageBridge.on(
            'scroll',
            ({ headerParallaxRate }) => {
              this.headerParallaxRateX.value = headerParallaxRate
            },
          )
          onBeforeUnmount(() => {
            // 释放头部下拉监听
            offScroll()
            // 释放商品数据
            this.goodsData.value.$destroy?.()
          })
        })
      }

      query = useQuery<{
        goodsId: string
        parentCommodityId: string
        skuId: string
        type: string
        onlyShowDetail: string
      }>()

      // 是否加载中
      loading = ref(true)

      onlyShowDetail = computed(() => {
        return this.query.onlyShowDetail === 'true'
      })

      // 商品数据
      goodsData = ref<GoodsData>({} as any)

      // 当前激活的 TAB
      activeTab = ref(0)

      // 头部下拉进度
      headerParallaxRateX = ref(0)

      scrolldistance = ref(0)

      getPageHeader = ({ navbarHeight }) => {
        this.scrolldistance.value = navbarHeight + 26
      }
    },
)
